import type { PipelineTile } from "../api";
import { ragTone } from "../tone";
import { MEASURES, measureChipClass, measureRag, tileNote, tileToneClass, toneDotClass } from "./measure";

/**
 * One Outputs-lane tile (`o1`-`o5`, `step: null`, lane `outputs`) — the same
 * compact tile shape as `StepTile` but with no step number, since an output
 * is not a pipeline step (UX-mockup prototype v2, frame 1 `.lane.out .st`).
 * `o1`-`o5` are never gates: only a `g`/`pg`-prefixed key is a gate.
 */
export function OutputTile({
  tile,
  onOpen,
  noun = "week",
}: {
  tile: PipelineTile;
  onOpen: (stageKey: string) => void;
  noun?: "week" | "month";
}) {
  const tone = ragTone(tile.overall_rag);
  const note = tileNote(tile, noun);

  return (
    <button
      type="button"
      data-nonmutating
      data-tile={tile.stage_key}
      data-tone={tone}
      onClick={() => onOpen(tile.stage_key)}
      className={`flex min-w-24 flex-col gap-1 rounded-ks-sm border bg-ks-surface px-2 py-1.5 text-left ${tileToneClass(tone)}`}
    >
      <span aria-hidden className={`h-2 w-2 shrink-0 rounded-full ${toneDotClass(tone)}`} />
      <span className="text-xs font-semibold leading-tight text-ks-ink">{tile.label}</span>
      <span className="flex gap-1" aria-hidden>
        {MEASURES.map((m) => (
          <span
            key={m.key}
            title={m.name}
            className={`flex h-4 w-4 items-center justify-center rounded text-[10px] font-bold ${measureChipClass(measureRag(tile, m.key))}`}
          >
            {m.letter}
          </span>
        ))}
      </span>
      {note && <span className="text-[10px] leading-tight text-ks-grey-1">{note}</span>}
    </button>
  );
}
